import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';
import * as moment from 'moment';

@Component({
  selector: 'app-increase-price',
  templateUrl: './increase-price.component.html',
  styleUrls: ['./increase-price.component.css']
})
export class IncreasePriceComponent implements OnInit {
  loading = false;
  endDateTimer: any;
  countdownEndTime: any;
  countdownString: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IncreasePriceComponent>,
    private _auctions: AuctionsService,
    public _config: ConfigService
  ) {
  }

  ngOnInit() {
    this.timer();
    this.endDateTimer = moment(this.data.auctionData.end_date).add(2, 'hours').format();
  }
  confirm() {
    this.loading = true;
    this._auctions.increasePrice(this.data.auctionData.id).subscribe({
      next: (data: any) => {

        // this._config.toastrService.success(data.message);
        this.dialogRef.close('success');
      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });  
        this._config.showErrors(error);
        this.dialogRef.close();

      }
    });
  }

  timer() {
    // set the countdown end time
    this.countdownEndTime = moment(this.data.auctionData.end_date).add(2, 'hours');
    this.countDown();
    // update the countdown every second
    setInterval(() => {
      this.countDown();

    }, 1000);
  }


  countDown() {
    const timeRemaining = this.countdownEndTime.diff(moment());

    // check if the countdown has ended
    if (timeRemaining <= 0) {
      this.countdownString = "Countdown ended!";
      return;
    }

    // calculate the hours, minutes, and seconds remaining using Moment.js
    const duration = moment.duration(timeRemaining);
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    // format the time remaining as astring
    this.countdownString = hours + " hr : " + minutes + " mins : " + seconds + " secs";
  }

  topUp() {
    this._config.goTo('myProfile');
    this.dialogRef.close();
  }
}
